<template>
  <div class="c culculation-request">
    <h1 class="text-white">{{ $t('calculationrequestform.introheader') }}</h1>
    <calculation-request-form-button
      v-show="!formOpened"
      @click.native="toggleForm"
    >
      <template v-slot:text>
        {{ $t('calculationrequestform.downloadList') }}
      </template>
    </calculation-request-form-button>
    <validation-observer
      name="calculationRequestForm"
      ref="calculationRequestForm"
      v-show="formOpened"
      v-slot="{ invalid, handleSubmit }"
    >
      <form
        class="culculation-request__form"
        @submit.prevent="handleSubmit(submitForm)"
      >
        <p class="c text-white">
          {{ $t('calculationrequestform.contactInfoIntroText') }}
        </p>

        <!-- Bedrijfsnaam -->
        <div class="form-group">
          <label for="companyName" class="text-white">
            {{ $t('calculationrequestform.label.companyname') }}
          </label>
          <input
            v-model.lazy="companyName"
            type="text"
            name="companyName"
            id="companyName"
            class="w-100"
          />
        </div>
        <!-- /Bedrijfsnaam -->

        <!-- Naam -->
        <div class="form-group">
          <label for="name" class="text-white">
            {{ $t('calculationrequestform.label.name') }} <span class="text-danger">*</span>
          </label>
          <validation-provider
            name="Naam"
            rules="required"
            v-slot="{ errors, failed }"
          >
            <input
              :class="{ 'with-error': failed }"
              class="w-100"
              v-model.lazy="name"
              type="text"
              name="name"
              id="name"
            />
            <span class="error text-white">{{ errors[0] }}</span>
          </validation-provider>
        </div>
        <!-- /Naam -->

        <!-- E-mail -->
        <div class="form-group">
          <label for="email" class="text-white">
            {{ $t('calculationrequestform.label.email') }} <span class="text-danger">*</span>
          </label>
          <validation-provider
            name="E-mail"
            rules="required|email"
            v-slot="{ errors, failed }"
          >
            <input
              :class="{ 'with-error': failed }"
              v-model.lazy="email"
              type="email"
              name="email"
              id="email"
              class="w-100"
            />
            <span class="error text-white">{{ errors[0] }}</span>
          </validation-provider>
        </div>
        <!-- /E-mail -->

        <!-- Telefoonnummer -->
        <div class="form-group">
          <label for="phoneNumber" class="text-white">
            {{ $t('calculationrequestform.label.phoneNumber') }}
          </label>
          <input
            v-model.lazy="phoneNumber"
            type="text"
            name="phoneNumber"
            id="phoneNumber"
            class="w-100"
          />
        </div>
        <!-- /Telefoonnummer -->

        <!-- Street -->
        <div class="form-group">
          <label for="addressStreet" class="text-white">
            {{ $t('calculationrequestform.label.addressStreet') }} <span class="text-danger">*</span>
          </label>
          <validation-provider
            name="addressStreet"
            rules="required"
            v-slot="{ errors, failed }"
          >
            <input
              :class="{ 'with-error': failed }"
              v-model.lazy="addressStreet"
              type="text"
              name="addressStreet"
              id="addressStreet"
              class="w-100"
            />
            <span class="error text-white">{{ errors[0] }}</span>
          </validation-provider>
        </div>
        <!-- /Street -->

        <!-- Zipcode -->
        <div class="form-group">
          <label for="addressZipcode" class="text-white">
            {{ $t('calculationrequestform.label.addressZipcode') }} <span class="text-danger">*</span>
          </label>
          <validation-provider
            name="addressZipcode"
            rules="required"
            v-slot="{ errors, failed }"
          >
            <input
              :class="{ 'with-error': failed }"
              v-model.lazy="addressZipcode"
              type="text"
              name="addressZipcode"
              id="addressZipcode"
              class="w-100"
            />
            <span class="error text-white">{{ errors[0] }}</span>
          </validation-provider>
        </div>
        <!-- /Zipcode -->

        <!-- City -->
        <div class="form-group">
          <label for="addressCity" class="text-white">
            {{ $t('calculationrequestform.label.addressCity') }} <span class="text-danger">*</span>
          </label>
          <validation-provider
            name="addressCity"
            rules="required"
            v-slot="{ errors, failed }"
          >
            <input
              :class="{ 'with-error': failed }"
              v-model.lazy="addressCity"
              type="text"
              name="addressCity"
              id="addressCity"
              class="w-100"
            />
            <span class="error text-white">{{ errors[0] }}</span>
          </validation-provider>
        </div>
        <!-- /City -->

        <!-- Terms -->
        <validation-provider
          name="Privacy voorwaarden"
          :rules="{ required: { allowFalse: false } }"
          v-slot="{ errors }"
        >
          <div class="form-group">
            <div class="flex items-center">
              <input
                class="inline-block"
                type="checkbox"
                name="terms"
                id="terms"
                v-model="termsAccepted"
              />
              <span class="inline-block ml-10 text-white"
                >{{ agreeWithLabel }}
                <a
                  :href="privacyUrl"
                  target="_blank"
                  :title="privacyStatementTooltip"
                  class="text-white"
                  >{{ privacyStatement }}</a
                >
              </span>
            </div>
            <span class="error text-white">{{ errors[0] }}</span>
          </div>
        </validation-provider>
        <!-- /Terms-->
        <p v-if="submitted" class="text-white font-weight-normal">
          {{ $t('calculationrequestform.requestSent') }}
        </p>
        <calculation-request-form-button :disabled="invalid" v-show="!loading">
          <template v-slot:text>
            {{ $t('calculationrequestform.label.send') }}
          </template>
        </calculation-request-form-button>
        <loader v-show="loading" />
      </form>
    </validation-observer>
  </div>
</template>

<script>
import CalculationRequestFormButton from "./CalculationRequestFormButton";
  import Loader from "./Loader";
  import { mapState, mapGetters } from "vuex";

export default {
  name: "CalculationRequestForm",
  components: {
    CalculationRequestFormButton,
    Loader
  },
  data() {
    return {
      formOpened: false,
      loading: false,
      submitted: false,
      checkboxLabel: "Bla"
    };
  },
  computed: {
    ...mapState(["culture"]),
    ...mapGetters({
      privacyUrl: 'privacyUrl'
    }),
    agreeWithLabel: {
      get() {
        return this.$t('calculationrequestform.label.agreeWith')
      }
    },
    privacyStatementTooltip:{
      get(){
        return this.$t('calculationrequestform.label.privacyStatementTooltip')
      }
    },
    privacyStatement:{
      get(){
        return this.$t('calculationrequestform.label.privacyStatement')
      }
    },
    companyName: {
      get() {
        return this.$store.state.formData.companyName;
      },
      set(value) {
        this.$store.commit("SET_FORM_DATA", {
          property: "companyName",
          data: value
        });
      }
    },
    name: {
      get() {
        return this.$store.state.formData.name;
      },
      set(value) {
        this.$store.commit("SET_FORM_DATA", {
          property: "name",
          data: value
        });
      }
    },
    email: {
      get() {
        return this.$store.state.formData.email;
      },
      set(value) {
        this.$store.commit("SET_FORM_DATA", {
          property: "email",
          data: value
        });
      }
    },
    phoneNumber: {
      get() {
        return this.$store.state.formData.phoneNumber;
      },
      set(value) {
        this.$store.commit("SET_FORM_DATA", {
          property: "phoneNumber",
          data: value
        });
      }
    },
    addressStreet: {
      get() {
        return this.$store.state.formData.addressStreet;
      },
      set(value) {
        this.$store.commit("SET_FORM_DATA", {
          property: "addressStreet",
          data: value
        });
      }
    },
    addressZipcode: {
      get() {
        return this.$store.state.formData.addressZipcode;
      },
      set(value) {
        this.$store.commit("SET_FORM_DATA", {
          property: "addressZipcode",
          data: value
        });
      }
    },
    addressCity: {
      get() {
        return this.$store.state.formData.addressCity;
      },
      set(value) {
        this.$store.commit("SET_FORM_DATA", {
          property: "addressCity",
          data: value
        });
      }
    },
    termsAccepted: {
      get() {
        return this.$store.state.formData.termsAccepted;
      },
      set(value) {
        this.$store.commit("SET_FORM_DATA", {
          property: "termsAccepted",
          data: value
        });
      }
    },
    jsonViewModel() {
      return this.$store.getters.jsonViewModel;
    }
  },
  methods: {
    toggleForm() {
      // Toggle visibility
      this.formOpened = !this.formOpened;

      // Send GTM event
      this.$gtm.trackEvent({
        event: "Aero Calculator Opened",
        category: "Aero Calculator",
        action: "Opened form",
        label: "Opened form"
      });
    },
    async submitForm() {
      try {
        this.loading = true;
        await fetch(`./api/AeroConfigurator?culture=${this.culture}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(this.jsonViewModel)
        });

        this.loading = false;
        this.submitted = true;

        // Send GTM event
        this.$gtm.trackEvent({
          event: "Aero Calculator Submitted",
          category: "Aero Calculator",
          action: "Submitted form",
          label: "Submitted form"
        });
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    }
  }
};
</script>
